import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { from, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService
    ) {}

    // Intercept Http Requests and attach the cognito token
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.handle(request, next));
    }

    async handle(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
        const idToken = await this.authService.getIdToken();
        const accessToken = await this.authService.getAccessToken();

        if (idToken == null || accessToken == null) {
            return next.handle(request).toPromise();
        }
    
        request = request.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${idToken}`
            }
        });
    
        return next.handle(request).toPromise()
    }
}
